<ng-template #itemTemplate let-item="item">
  <div class="category-group-selection-panel-group-name">
    <div class="line-ellipsis">{{ item.name }}</div>
  </div>
</ng-template>

<ng-template #selectionTemplate let-item="item">
  <div class="category-group-filter-name">{{ item.name }}</div>
</ng-template>

<ng-container [formGroup]="editorForm">
  <ca-selector
    #categoryGroupSelector
    formControlName="editor"
    [url]="categoryGroupSelectorOptions.url"
    [itemTemplate]="itemTemplate"
    [selectionTemplate]="selectionTemplate"
    [queryOperator]="categoryGroupSelectorOptions.queryOperator"
    [queryField]="categoryGroupSelectorOptions.queryField"
    [multiple]="false"
    [showSelections]="categoryGroupSelectorOptions.showSelections"
    [showClearSelections]="categoryGroupSelectorOptions.showClearSelections"
    [showClearSelectionLink]="categoryGroupSelectorOptions.showClearSelectionLink"
    [selectorPosition]="categoryGroupSelectorOptions.selectorPosition"
    [styles]="{ width: '100%', 'border-width': '0px' }"
    [pageSize]="categoryGroupSelectorOptions.pageSize"
    [currentPage]="categoryGroupSelectorOptions.currentPage"></ca-selector>
</ng-container>
